/* eslint-disable import/prefer-default-export */
import { Box, styled } from '@mui/material';

export const Center = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));
